<template>
    <div>
        <button type="button" @click="showDatepicker=!showDatepicker" class="btn btn-big choose-date fleft">Choose date</button>
        <div class="box" :class="{active:showDatepicker}">
            <div class="header">
                <button type="button" class="btn btn-primary" @click="prevMonth">Prev</button>
                <p>{{title}}</p>
                <button type="button" class="btn btn-primary" @click="nextMonth">Next</button>
            </div>
            <div class="dates">
                <transition name="fade">
                    <table class="table">
                        <thead>
                            <tr class="table-active">
                                <th class="cell day-header">Mon</th>
                                <th class="cell day-header">Tue</th>
                                <th class="cell day-header">Wed</th>
                                <th class="cell day-header">Thu</th>
                                <th class="cell day-header">Fri</th>
                                <th class="cell day-header">Sat</th>
                                <th class="cell day-header">Sun</th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr :key="'index'+index1" v-for="(weeks,index1) in days">
                            <td v-for="(day, index2) in weeks">
                                <button v-if="days[index1][index2]!=''" @click="changeCurrentDate(days[index1][index2])">{{days[index1][index2]}}</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        props:['currentDate'],
        data(){
            return{
                showDatepicker: false,
                start:false,
                days:null,
                date: null,
                day: null,
                year : null,
                month: null,
                title:null,
                weeks:null,
                daysInMonth: null,
                weekDay:["Sunday","Monday","Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
                weekDayShort:["Sun","Mon","Tue", "Wed", "Thu", "Fri", "Sat" ],
                monthList:[ "January", "February", "March", "April", "May",
                    "June", "July", "August", "September", "October", "November","December"]
            }
        },
        mounted(){
            this.updateLayout(this.currentDate)
        },
        methods:{
            updateLayout(date){
                this.start=false;
                this.setDate(date);
                this.getDaysInMonth();
                this.weekCount();
                this.fillCalendar();
            },
            changeCurrentDate(day){
                let month = this.month+1;
                let date = day;
                if(this.month<10){
                    month = "0"+month;
                }
                if(day<10){
                    date = "0" + day;
                }
                const newDate = this.year + "-" + month + "-" + date;
                this.showDatepicker = false;
                this.$emit('dateWasChanged', newDate);
            },
            check(d,w,counter){
                if(d===this.day && this.start===false){
                    this.start=true;
                    return true;
                } else if (this.start===true && counter <= this.daysInMonth){
                    return true;
                } else {
                    return false;
                }
            },
            fillCalendar(){
                let counter = 1;
                let tmp_array = new Array(this.weeks);
                for(let w = 1; w<this.weeks; w++){
                    tmp_array[w] = new Array(7);
                }
                for(let w = 1; w<this.weeks; w++){
                    for(let d = 0; d<7; d++){
                        if(this.check(d,w, counter)){
                            tmp_array[w][d] = parseInt(counter);
                            counter=counter+1;
                        }else{
                            tmp_array[w][d] = '';
                        }
                    }
                }
                this.days = tmp_array;
            },
            updateCurrentDate(){
                let month = this.month+1;
                if(this.month<10){
                    month = "0"+month;
                }
                let date = this.date;
                if(date<10){
                    date = "0" + date;
                }
                const newDate = this.year + "-" + month + "-" + date;
                this.updateLayout(newDate)
            },
            nextMonth(){
                if(this.month<11){
                  this.month++;
                }else if(this.month===11){
                  this.month = 0;
                  this.year++;
                }
                this.updateCurrentDate();
            },
            prevMonth(){
                if(this.month>0){
                    this.month--;
                }else if(this.month===0){
                    this.month = 11;
                    this.year--;
                }
                this.updateCurrentDate();
            },
            setDate(date){
                const tmp = date.split("-");
                this.date = parseInt(tmp[2]);
                this.year = parseInt(tmp[0]);
                this.month = parseInt(tmp[1])-1;
                this.title = this.year + " " + this.monthList[this.month];
            },
            getDaysInMonth () {
                this.daysInMonth = new Date(this.year, this.month+1, 0).getDate();
            },
            weekCount() {
                const firstOfMonth = new Date(this.year, this.month, 1);
                this.day = firstOfMonth.getDay()-1;
                const lastOfMonth = new Date(this.year, this.month+1, 0);

                const used = firstOfMonth.getDay() + 6 + lastOfMonth.getDate();
                this.weeks = Math.ceil( used / 7);
            }

        }


    }
</script>
<style scoped>
    .box{
        display: none;
        position: absolute;
        top:46px;
        left:0;
        background: #fff;
        border: 1px solid #e7e7e7;
        padding:5px;
        z-index: 200;
        zoom: 1.75;
    }
    .box.active{
        display: block;
    }
    .box .header{
        display:flex;
        justify-content:space-between;
        margin-bottom: 10px;
    }
    .box .header p{
        line-height: 34px;
        margin: 0;
    }
    .box table{
        width: 100%;
        text-align: center;
    }
    .box table td{
        width: 14.28571428%;
        padding: 5px;
    }
    .box table td button{
        width: 100%;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Diary/Datepicker.vue